import { PERSOENLICHE_FELDER, PASS_FELDER, DOKUMENT_TYPEN } from './teilnehmer-felder';
import { isFeldRequired } from './teilnehmer-passdaten.utils';
import { formatAndCalculateReleasedatum } from '@/core/common/helpers/utils';

// Kategorien der Passdaten-Konfiguration
const ABSCHNITTE = [
  { titel: 'Persönliche Daten', felder: PERSOENLICHE_FELDER },
  { titel: 'Passdaten', felder: PASS_FELDER },
  { titel: 'Dokumente', felder: DOKUMENT_TYPEN },
];

function feldKeys(feld) {
  if (feld.apiValue == null) return [feld.key];
  return [feld.key, feld.apiValue.charAt(0).toLowerCase() + feld.apiValue.slice(1)];
}

// Gliedert eine flache Anforderungsliste nach den Kategorien der Passdaten-Konfiguration
export function buildAnforderungsAbschnitte(anforderungen) {
  if (anforderungen == null || anforderungen.length === 0) return [];

  const abschnitte = [];

  for (const abschnitt of ABSCHNITTE) {
    const eintraege = [];
    for (const feld of abschnitt.felder) {
      const keys = feldKeys(feld);
      const anforderung = anforderungen.find(eintrag => keys.includes(eintrag.key));
      if (anforderung == null) continue;
      eintraege.push({ label: feld.label, erfuellt: anforderung.erfuellt });
    }
    if (eintraege.length > 0) abschnitte.push({ titel: abschnitt.titel, eintraege });
  }

  return abschnitte;
}

// Listet die laut Konfiguration benötigten Felder, gegliedert nach denselben Kategorien
export function buildKonfigurationsAbschnitte(konfiguration) {
  if (konfiguration == null) return [];

  return ABSCHNITTE.map(abschnitt => ({
    titel: abschnitt.titel,
    eintraege: abschnitt.felder
      .filter(feld => isFeldRequired(konfiguration, feld))
      .map(feld => ({ label: feld.label })),
  })).filter(abschnitt => abschnitt.eintraege.length > 0);
}

// Hinweise der Passdaten-Konfiguration (Grund, Benachrichtigung, Dringlichkeit, Einreichungsfrist)
export function buildKonfigurationsHinweise(konfiguration, reisetermin) {
  if (konfiguration == null) return [];

  const hinweise = [];
  if (konfiguration.grund) hinweise.push(`Grund für Passdaten: ${konfiguration.grund}`);
  if (konfiguration.benachrichtigungAnCmVorRelease) hinweise.push('Benachrichtigung an CM vor Release');
  if (konfiguration.dringlichkeit) hinweise.push(`Dringlichkeit: ${konfiguration.dringlichkeit}h`);
  if (konfiguration.einreichungsfristZumErstenReleasedatum != null) {
    hinweise.push(
      einreichungsfristHinweis(konfiguration.einreichungsfristZumErstenReleasedatum, reisetermin)
    );
  }

  return hinweise;
}

// Die größte Releasefrist ergibt das erste, die kleinste das letzte Releasedatum
function einreichungsfristHinweis(zumErstenReleasedatum, reisetermin) {
  const label = zumErstenReleasedatum ? 'Erstes Releasedatum' : 'Letztes Releasedatum';
  const releasefristen = reisetermin?.metadata?.releasefrist;
  if (!reisetermin?.startdatum || !releasefristen?.length) return `Einreichungsfrist: ${label}`;

  const releasefrist = zumErstenReleasedatum ? Math.max(...releasefristen) : Math.min(...releasefristen);
  const releasedatum = formatAndCalculateReleasedatum(reisetermin.startdatum, releasefrist);
  return `Einreichungsfrist: ${label} (${releasedatum})`;
}
